<template>
    <div class="table-container">
      <div v-if="alertMessage" class="custom-alert">
        {{ alertMessage }}
      </div>
      <table>
        <thead>
          <tr>
            <th v-for="(column, index) in columns" :key="index">{{ column }}</th>
          </tr>
        </thead>
        <!-- <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td v-for="(column, colIndex) in columns" :key="colIndex">
              <template v-if="column === '¿Eliminar?'">
                <select class="input-field" v-model="item.eliminar">
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </select>
              </template>
              <template v-else>
                {{ item[getPropertyName(column)] }}
              </template>
            </td>
          </tr>
        </tbody> -->
        <tbody v-if="items.length > 0">
          <tr v-for="(item, index) in items" :key="index">
            <td v-for="(column, colIndex) in columns" :key="colIndex">
              <template v-if="column === '¿Eliminar?'">
                <select class="input-field" v-model="item.eliminar">
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </select>
              </template>
              <template v-else>
                {{ item[getPropertyName(column)] }}
              </template>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="columns.length" class="empty-message">
              No hay datos disponibles
            </td>
          </tr>
        </tbody>

      </table>
    </div>
  </template>

<script>

import IberoHelpers from '@/store/helpers.js'

export default {
  components: {
    IberoHelpers,
  },
  data () {
    return {
      alertMessage: '',
    }
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
  methods: {
    showAlert (message) {
      this.alertMessage = message

      // Oculta el alert después de 3 segundos
      setTimeout(() => {
        this.alertMessage = ''
      }, 5000)
    },
    // Función para convertir el nombre de la columna a la propiedad camelCase correspondiente
    getPropertyName (column) {
      const columnMap = {
        'CobraComisionCon': 'cobraComisionCon',
        'Observaciones': 'observaciones',
        'Periodo': 'periodo',
        'Id Banner': 'idBanner',
        'Documento': 'documento',
        'Número Orden': 'numero_Orden',
      }
      return columnMap[column] || column.toLowerCase().replace(/ /g, '')
    },
    //   sendDataOperators () {
    //     console.log(this.columns)
    //     const emptyFields = this.items.some(item => !item.eliminar || item.eliminar.trim() === '')
    //     if (emptyFields) {
    //       this.showAlert('Todos los campos "¿Eliminar?" deben estar llenos.')
    //       return
    //     }
    //     else{
    //       IberoHelpers.PostAnuladosvsConsolidado(this.$store, this.items)
    //       this.$emit('nextModalAnuladosvsConsolidado');
    //       console.log(this.items)
    //     }

    //   },
    sendDataOperators () {
      console.log(this.columns)

      // Verificar si hay campos "¿Eliminar?" vacíos
      const emptyFields = this.items.some(item => !item.eliminar || item.eliminar.trim() === '')
      if (emptyFields) {
        this.showAlert('Todos los campos "¿Eliminar?" deben estar llenos.')
        return
      }

      // Verificar propiedades nulas y asignar valores vacíos si es necesario
      const sanitizedItems = this.items.map(item => {
        const sanitizedItem = { ...item }
        for (const key in sanitizedItem) {
          if (sanitizedItem[key] === null) {
            sanitizedItem[key] = '' // Cambiar null por cadena vacía
          }
        }
        return sanitizedItem
      })

      IberoHelpers.PostAnuladosvsConsolidado(this.$store, sanitizedItems)
        .then(() => {
          // Emitir el evento después de que PostAnulados termine
          this.$emit('nextModalAnuladosvsConsolidado')
          console.log(sanitizedItems)
        })
        .catch((error) => {
          console.error('Error al ejecutar PostAnulados:', error)
          // Opcional: manejar el error, como mostrar un mensaje al usuario
        })
    },
  },
}
</script>

    <style scoped>
    .table-container {
      max-height: 300px;
      overflow-y: auto;
      overflow-x: hidden;
      width: 100%;
      box-sizing: border-box;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      text-align: left;
    }

    th,
    td {
      padding: 8px;
      border: 1px solid #ddd;
    }

    thead {
      background-color: #f4f4f4;
      position: sticky;
      top: 0;
      z-index: 1;
    }

    tr:nth-child(even) {
      background-color: #f9f9f9;
    }

    tr:hover {
      background-color: #f1f1f1;
    }

    .input-field {
      width: 100%;
      padding: 5px;
      box-sizing: border-box;
    }
    .custom-alert {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #ff4444; /* Color de fondo rojo */
    color: white;
    padding: 15px 20px;
    border-radius: 5px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000; /* Asegura que esté encima de otros elementos */
    font-size: 16px;
    text-align: center;
    animation: fadeInOut 3s ease-in-out;
  }

  @keyframes fadeInOut {
    0% { opacity: 0; transform: translateX(-50%) translateY(-10px); }
    10% { opacity: 1; transform: translateX(-50%) translateY(0); }
    90% { opacity: 1; transform: translateX(-50%) translateY(0); }
    100% { opacity: 0; transform: translateX(-50%) translateY(-10px); }
  }
    </style>
